import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
function StickyRequestBanner(_ref) {
  var isValid = _ref.isValid,
    resourceId = _ref.resourceId,
    handleShowModal = _ref.handleShowModal,
    consultantName = _ref.consultantName;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "sticky-request-edit-banner d-none d-sm-block ".concat(isValid ? '' : 'not-valid')
  }, /*#__PURE__*/React.createElement("div", {
    className: "container g-row g-row--between"
  }, /*#__PURE__*/React.createElement("div", null, isValid ? /*#__PURE__*/React.createElement("div", {
    className: "sticky-message"
  }, /*#__PURE__*/React.createElement("strong", null, "Requesting edits: "), "Tell", ' ', /*#__PURE__*/React.createElement("strong", null, consultantName), ' ', "general and/or specific changes that must be addressed.") : /*#__PURE__*/React.createElement("div", {
    className: "sticky-message"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), /*#__PURE__*/React.createElement("strong", null, "Requesting edits: "), "Add at least 1 comment to be able to send and request edits.")), /*#__PURE__*/React.createElement("div", {
    className: "sticky-request-edit-banner-actions g-row"
  }, /*#__PURE__*/React.createElement("a", {
    className: "invoice-cancel-request-edit btn btn-alt border-white text-white me-3",
    href: "/invoices/".concat(resourceId)
  }, "Cancel"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-alt-secondary bg-white",
    onClick: function onClick() {
      return handleShowModal();
    }
  }, "Send Edits")))), /*#__PURE__*/React.createElement("div", {
    className: "sticky-request-edit-banner mobile-sticky ".concat(isValid ? '' : 'not-valid')
  }, /*#__PURE__*/React.createElement("div", {
    className: "container g-row g-row--between"
  }, /*#__PURE__*/React.createElement("div", null, isValid ? /*#__PURE__*/React.createElement("div", {
    className: "sticky-message"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-edit"
  }), /*#__PURE__*/React.createElement("strong", null, "Requesting edits:"), ' ', "Add comments first.") : /*#__PURE__*/React.createElement("div", {
    className: "sticky-message"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), /*#__PURE__*/React.createElement("strong", null, "Requesting edits:"), "Add at least 1 comment to be able to send and request edits.")), /*#__PURE__*/React.createElement("div", {
    className: "sticky-request-edit-banner-actions"
  }, /*#__PURE__*/React.createElement("a", {
    className: "invoice-cancel-request-edit btn btn-alt border-white text-white me-3",
    href: "/invoices/".concat(resourceId)
  }, "Cancel"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-alt-secondary bg-white",
    onClick: function onClick() {
      return handleShowModal();
    }
  }, "Send Edits")))));
}
StickyRequestBanner.propTypes = {
  isValid: PropTypes.bool.isRequired,
  resourceId: PropTypes.string.isRequired,
  consultantName: PropTypes.string.isRequired,
  handleShowModal: PropTypes.func.isRequired
};
export default StickyRequestBanner;